export default __webpack_public_path__ + "static/media/modern-design-system-light.67c15b58.jpg";